import { progressFillPercent } from "helpers/progress";

// A determinate progress track: evergreen fill on oat, width eased so a
// step forward reads as motion rather than a jump.

export default function ProgressBar({
  percentage,
  label,
}: {
  /** 0–100. */
  percentage: number;
  /** What the bar measures, for assistive tech. */
  label: string;
}) {
  const clamped = Math.max(0, Math.min(100, percentage));
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
      aria-label={label}
      className="h-2 overflow-hidden rounded-full bg-oat-200"
    >
      <div
        className="h-full rounded-full bg-evergreen transition-[width] duration-300 ease-out"
        style={{ width: `${progressFillPercent(clamped)}%` }}
      />
    </div>
  );
}
